import { ToastContainer } from "react-toastify";
import Footer from "../../../components/footer";
import "./style.css";
import { useContext, useMemo, useState } from "react";
import Notification from "../../../components/toast";
import { ListFilter } from "../../../components/list-filter";
import { ModalFilterCollaborator } from "../../../components/register/register-colaborador/filter";
import { ContextRegisterCollaborator } from "../../../components/register/register-colaborador/context";
import { ModalRegisterCollaborator } from "../../../components/register/register-colaborador/modal-register";
import TableCollaborator from "../../../components/register/register-colaborador/table";
import HeaderReport from "../../../components/header/report";
import ModalMain from "../../../components/modal";
import { ModalRecoveryCollaborator } from "../../../components/register/register-colaborador/modal-recovery";
import ReportModalContent from "../../../components/report/ReportModalContent";

// Os relatórios genéricos (ReportModalContent/generateReport) esperam filtros no formato { chave: { label, value } }
const PARAM_LABELS = {
	nome: "Nome",
	cargo: "Cargo",
};

export const MainRegisterColaborador = () => {
	const options = {
		title: "Cadastro de Colaborador",
		subTitle: "Colaborador",
		identReport: `reportCollaborator`, //usado para definir os event listners
		reportColumns: [
			// Identificação
			{ key: "nome", label: "Nome", align: "left", visible: true },
			{ key: "email", label: "Email", align: "left", visible: true },

			// Documentos (exiba se você realmente usar)
			{ key: "cpf", label: "CPF", align: "center", visible: false },
			{ key: "rg", label: "RG", align: "center", visible: false },

			// Contatos
			{ key: "telefone_1", label: "Telefone 1", align: "center", visible: true },
			{ key: "telefone_2", label: "Telefone 2", align: "center", visible: false },
			{ key: "telefone_3", label: "Telefone 3", align: "center", visible: false },

			// Localização
			{ key: "nomecidade", label: "Cidade", align: "left", visible: true },
			{ key: "uf", label: "UF", align: "center", visible: true },

			// Endereço detalhado (opcionais)
			{ key: "rua", label: "Rua", align: "left", visible: false },
			{ key: "numero", label: "Número", align: "center", visible: false },
			{ key: "bairro", label: "Bairro", align: "left", visible: false },
			{ key: "cep", label: "CEP", align: "center", visible: false },
			{ key: "complemento", label: "Complemento", align: "left", visible: false },

			// Outros
			{ key: "tipo", label: "Tipo", align: "left", visible: false },
			{ key: "nascimento", label: "Nascimento", align: "left", format: "date", visible: false },
			{ key: "ativo", label: "Status", align: "center", format: "badgePgto", visible: true },
			{ key: "obs", label: "Observação", align: "left", visible: false },

			// IDs internos (geralmente ocultos no relatório)
			{ key: "id_funcionario", label: "ID Funcionário", align: "right", visible: false },
			{ key: "id_cidade", label: "ID Cidade", align: "right", visible: false },
			{ key: "id_cliente", label: "ID Cliente", align: "right", visible: false },
		],
	};
	const { openModalFilterCollaborator, openModalRegisterCollaborator, filterData, fetchAllCollaborators } =
		useContext(ContextRegisterCollaborator);

	const [reportData, setReportData] = useState([]);
	const [isLoadingReport, setIsLoadingReport] = useState(false);

	const open = () => {
		openModalFilterCollaborator();
	};

	const handleOpenModalReport = async () => {
		try {
			setIsLoadingReport(true);
			const data = await fetchAllCollaborators();
			setReportData(data);

			const event = new CustomEvent(`${options.identReport}`);
			window.dispatchEvent(event);
		} catch (error) {
			Notification.showToast({
				message: error.message,
				type: "warning",
			});
		} finally {
			setIsLoadingReport(false);
		}
	};

	const reportFilters = useMemo(() => {
		if (!filterData || typeof filterData !== "object") return {};

		const filters = {};

		if (filterData.param) {
			filters.param = {
				label: PARAM_LABELS[filterData.param] || "Parâmetro",
				value: filterData.paramValue || "",
			};
		}

		if (filterData.ativo) {
			filters.ativo = {
				label: "Ativo",
				value: filterData.ativo,
			};
		}

		return filters;
	}, [filterData]);

	return (
		<div className="container-register">
			<header className="mt-page">
				<div className="grid grid-cols-2">
					<div className="col-span-1">
						<HeaderReport title={options.title} subTitle={options.subTitle} />
					</div>
					<div className="col-span-1 flex justify-end">
						<ListFilter filterData={filterData} />
					</div>
				</div>
				<ModalFilterCollaborator />
				<ModalRegisterCollaborator />
				<ModalRecoveryCollaborator />
				<ToastContainer />

				<div className="d-flex flex-wrap justify-content-between align-items-center gap-3">
					<button
						className="min-w-40 btn btn-sm btn-success w-15"
						onClick={(e) => openModalRegisterCollaborator()}
					>
						{options.title}
					</button>
					<div className="flex gap-2 flex-wrap ">
						<button className="min-w-40 btn btn-sm btn-primary w-25" onClick={(e) => open(e)}>
							Listar
						</button>
						{options.reportColumns && (
							<button
								className="min-w-40 btn btn-sm btn-danger"
								onClick={handleOpenModalReport}
								disabled={isLoadingReport}
							>
								{isLoadingReport ? "Carregando..." : "Relatório"}
							</button>
						)}
					</div>
				</div>
				{/* <div className="d-flex align-items-center justify-content-between">
					<button className="btn btn-sm btn-success w-15" onClick={(e) => openModalRegisterCollaborator()}>
						Cadastrar Colaborador
					</button>

					<button className="btn btn-sm btn-primary w-25" onClick={(e) => open()}>
						Listar
					</button>
				</div> */}
			</header>
			<main>
				<TableCollaborator />
			</main>
			<footer>
				<Footer />
			</footer>
			<ModalMain ident={options.identReport}>
				<ReportModalContent
					reportColumns={options.reportColumns}
					data={reportData}
					filters={reportFilters}
					title={options.title}
					headerSubtitle={options.subTitle}
					defaultFormat="pdf" // ou "csv"
				/>
			</ModalMain>
		</div>
	);
};
